import React from 'react'
import clsx from 'clsx'
import { Category } from 'iconsax-react'
import { useTheme } from '@mui/material'
import Dropdown from '@SonarCX/components/atoms/Dropdown'

const CategorySection = ({
  classes,
  handleChange,
  categories,
  values,
  canEdit
}) => {
  const theme = useTheme()

  const handleSelect = React.useCallback(
    id => {
      handleChange('section')({ target: { value: id } })
    },
    [handleChange]
  )

  return (
    <div className={clsx(classes.center, classes.label, classes.mobile)}>
      <span className={clsx(classes.center, classes.label)}>
        <Category
          size={theme.size.base}
          variant='Bulk'
          color={theme.palette.primary.main}
        />
        CATEGORY
      </span>

      <Dropdown
        options={categories.map(({ id }) => id)}
        renderOption={id => {
          const opt = categories.find(category => category.id === id)
          if (opt) {
            return <div key={opt.id}>{opt.name}</div>
          } else {
            return ''
          }
        }}
        selected={values.section === '' ? values.category : values.section}
        onSelect={handleSelect}
        hideAdd
        duplicates
        disablePortal
        disabled={!canEdit}
      >
        {(() => {
          const section =
            categories.find(({ id }) => id === values.section) ??
            categories.find(({ id }) => id === values.category)
          return (
            <div data-testid='task-category'>
              {section?.name || 'Unassigned'}
            </div>
          )
        })()}
      </Dropdown>
    </div>
  )
}

export default CategorySection
